import tinycolor from 'tinycolor2';
import Color from "color";
export class ColorTheme {
    current(): 'dark'|'light'
    {
        // @ts-ignore
        return getComputedStyle(document.documentElement).getPropertyValue('--theme-mode') || 'light';
    }

    colorToLightBg(color: string) {
        return Color(color).lighten(0.5).string();
    }

    colorToDarkBg(color: string) {
        return Color(color).darken(0.5).string();
        // return tinycolor(color).darken(50).toHexString();
    }

    /* colorToBg(color: string) {
        const value = 50;
        return this.current() === 'light'
            ? 'red' // tinycolor(color).lighten(value).toHexString()
            : 'blue' // tinycolor(color).darken(value).toHexString();
    } */
}

export const colorTheme = new ColorTheme();